// DATA
export const getNewsShoppingNewsData = state => state.news.getIn(['shoppingNews', 'data'])
export const getSelectedShoppingNews = state => getNewsShoppingNewsData(state).get('selectedNews')

// UI
export const getNewsShoppingNewsUi = state => state.news.getIn(['shoppingNews', 'ui'])
export const getShowShoppingDialog = state => getNewsShoppingNewsUi(state).get('active')
export const getShoppingNewsLoading = state => getNewsShoppingNewsUi(state).get('loadingNews')
export const isShoppingNewsSuccess = state => getNewsShoppingNewsUi(state).get('shoppingSuccess')
